import { all, call, put } from '@redux-saga/core/effects';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';

import { fetchPatientWorkQueue as fetchPatientWorkQueueAPI } from '../api/fetchPatientWorkQueue';
import { fetchReviewers as fetchReviewersAPI } from '../api/fetchReviewers';
import { patientWorkQueueActions } from '../PatientWorkQueue.slice';

type FetchQueuePayload = {
  isXsolisUser: boolean;
  teamId?: string;
};

export const $fetchPatientWorkQueue = createAction<FetchQueuePayload>(
  'sagas/fetchPatientWorkQueue'
);

export function* fetchPatientWorkQueue(
  action: PayloadAction<FetchQueuePayload>
): SagaIterator {
  const { isXsolisUser, teamId } = action.payload;

  const {
    LOADING,
    SET_PATIENTS,
    SET_REVIEWERS,
    REJECTED,
    SET_SETTINGS,
    SET_PAGINATION_TOTALS,
  } = patientWorkQueueActions;

  try {
    yield put(LOADING(true));

    const [patientResult, reviewerResult] = yield all([
      call(fetchPatientWorkQueueAPI, { teamId }),
      call(fetchReviewersAPI),
    ]);

    const { count: patientsCount, patients, column_settings } = patientResult;

    yield put(
      SET_PATIENTS({
        patients,
        isXsolisUser,
      })
    );

    yield put(SET_PAGINATION_TOTALS({ count: patientsCount }));
    yield put(SET_SETTINGS(column_settings));

    const { count: reviewersCount, users } = reviewerResult;

    yield put(
      SET_REVIEWERS({
        reviewers: users,
        count: reviewersCount,
      })
    );

    yield put(LOADING(false));
  } catch (error) {
    yield put(LOADING(false));
    yield put(REJECTED(error));
  }
}
